import React, { useState, useEffect } from 'react';
import './Mangerclint.css';

const ManagerDashboard = () => {
  // Team members data
  const [teamMembers, setTeamMembers] = useState([
    { id: 1, name: 'Priya Sharma', role: 'Senior Executive', email: 'priya@company.com', phone: '+91 98765 43210', joinDate: '2024-01-15', status: 'Active', target: 5000000, achieved: 4600000, leads: 8, dealsWon: 5, avatar: 'P', color: '#3b82f6' },
    { id: 2, name: 'Karan Verma', role: 'Executive', email: 'karan@company.com', phone: '+91 98765 43211', joinDate: '2024-02-10', status: 'Active', target: 3500000, achieved: 2160000, leads: 6, dealsWon: 3, avatar: 'K', color: '#10b981' },
    { id: 3, name: 'Neha Gupta', role: 'Manager', email: 'neha@company.com', phone: '+91 98765 43212', joinDate: '2023-11-20', status: 'Active', target: 4000000, achieved: 1200000, leads: 5, dealsWon: 2, avatar: 'N', color: '#8b5cf6' },
    { id: 4, name: 'Raj Malhotra', role: 'Sales Executive', email: 'raj@company.com', phone: '+91 98765 43213', joinDate: '2024-03-05', status: 'Active', target: 2500000, achieved: 500000, leads: 3, dealsWon: 1, avatar: 'R', color: '#ef4444' },
    { id: 5, name: 'Aarav Mehta', role: 'Admin', email: 'aarav@company.com', phone: '+91 98765 43214', joinDate: '2023-10-01', status: 'Active', target: 0, achieved: 0, leads: 2, dealsWon: 1, avatar: 'A', color: '#4f46e5' }
  ]);

  // Team performance metrics
  const [teamMetrics] = useState({
    totalLeads: 24,
    totalDealsWon: 12,
    totalRevenue: 8460000,
    totalTarget: 15000000,
    activeMembers: 5,
    pendingApprovals: 3,
    avgWinRate: 67,
    monthlyGrowth: '+15%'
  });

  // Monthly team performance data
  const monthlyPerformance = [
    { month: 'Jan', revenue: 420000, target: 400000, leads: 4 },
    { month: 'Feb', revenue: 680000, target: 450000, leads: 5 },
    { month: 'Mar', revenue: 1120000, target: 500000, leads: 6 },
    { month: 'Apr', revenue: 1460000, target: 550000, leads: 7 },
    { month: 'May', revenue: 980000, target: 600000, leads: 5 },
    { month: 'Jun', revenue: 1250000, target: 650000, leads: 6 }
  ];

  // Recent activities
  const [recentActivities, setRecentActivities] = useState([
    { id: 1, user: 'Priya Sharma', action: 'Generated PO', target: 'PO-2025-014', time: '2 hours ago', type: 'success' },
    { id: 2, user: 'Karan Verma', action: 'Added New Client', target: 'BluePeak Foods', time: '5 hours ago', type: 'info' },
    { id: 3, user: 'Neha Gupta', action: 'Renewed Contract', target: 'Orbit Logistics', time: '1 day ago', type: 'warning' },
    { id: 4, user: 'Raj Malhotra', action: 'Sent Quotation', target: 'Stellar Solutions', time: '2 days ago', type: 'info' },
    { id: 5, user: 'Priya Sharma', action: 'Deal Won', target: 'Acme Industries - ₹9.2L', time: '3 days ago', type: 'success' }
  ]);

  // Modal states
  const [isViewMemberModalOpen, setIsViewMemberModalOpen] = useState(false);
  const [isAssignTargetModalOpen, setIsAssignTargetModalOpen] = useState(false);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [targetForm, setTargetForm] = useState({ target: '', quarter: 'Q2', notes: '' });
  const [approvalForm, setApprovalForm] = useState({ action: '', comments: '' });
  const [reportPeriod, setReportPeriod] = useState('monthly');

  // Format currency
  const formatCurrency = (amount) => {
    if (amount >= 10000000) return `₹${(amount / 10000000).toFixed(1)}Cr`;
    if (amount >= 100000) return `₹${(amount / 100000).toFixed(1)}L`;
    return `₹${amount.toLocaleString('en-IN')}`;
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  // Calculate team achievement percentage
  const teamAchievement = (teamMetrics.totalRevenue / teamMetrics.totalTarget) * 100;

  // Get max revenue for chart
  const maxRevenue = Math.max(...monthlyPerformance.map(m => Math.max(m.revenue, m.target)));

  // View team member details
  const viewMemberDetails = (member) => {
    setSelectedMember(member);
    setIsViewMemberModalOpen(true);
  };

  // Assign target to member
  const assignTarget = (member) => {
    setSelectedMember(member);
    setTargetForm({ target: member.target.toString(), quarter: 'Q2', notes: '' });
    setIsAssignTargetModalOpen(true);
  };

  // Submit target assignment
  const submitTargetAssignment = () => {
    if (!targetForm.target) {
      alert('Please enter target amount');
      return;
    }

    const updatedMembers = teamMembers.map(m => {
      if (m.id === selectedMember.id) {
        return { ...m, target: parseFloat(targetForm.target) };
      }
      return m;
    });

    setTeamMembers(updatedMembers);
    alert(`✅ Target of ${formatCurrency(parseFloat(targetForm.target))} assigned to ${selectedMember.name}`);
    setIsAssignTargetModalOpen(false);
  };

  // Open approval modal
  const openApprovalModal = () => {
    setIsApproveModalOpen(true);
  };

  // Submit approval
  const submitApproval = () => {
    if (!approvalForm.action) {
      alert('Please select an action');
      return;
    }
    alert(`✅ ${approvalForm.action === 'approve' ? 'Approved' : 'Rejected'} with comments: ${approvalForm.comments || 'No comments'}`);
    setIsApproveModalOpen(false);
    setApprovalForm({ action: '', comments: '' });
  };

  // Generate report
  const generateReport = () => {
    alert(`📊 Generating ${reportPeriod} performance report...`);
    setIsReportModalOpen(false);
  };

  // Get activity icon based on type
  const getActivityIcon = (type) => {
    switch(type) {
      case 'success': return '✅';
      case 'warning': return '⚠️';
      default: return 'ℹ️';
    }
  };

  return (
    <div className="mgr-container">
      <div className="mgr-wrapper">
        {/* Header Section */}
        <div className="mgr-header">
          <div className="mgr-header-left">
            <h1 className="mgr-title">👨‍💼 Manager Dashboard</h1>
            <p className="mgr-subtitle">Team Performance · Approvals · Reports & Analytics</p>
          </div>
          <div className="mgr-header-actions">
            <button className="mgr-report-btn" onClick={() => setIsReportModalOpen(true)}>
              📊 Generate Report
            </button>
            <button className="mgr-approval-btn" onClick={openApprovalModal}>
              ⚡ Pending Approvals ({teamMetrics.pendingApprovals})
            </button>
          </div>
        </div>

        {/* Team Achievement Banner */}
        <div className="mgr-achievement-banner">
          <div className="mgr-achievement-left">
            <span className="mgr-achievement-icon">🎯</span>
            <div>
              <div className="mgr-achievement-label">Team Achievement</div>
              <div className="mgr-achievement-percent">{teamAchievement.toFixed(1)}%</div>
            </div>
          </div>
          <div className="mgr-achievement-center">
            <div className="mgr-progress-bar-container">
              <div className="mgr-progress-bar" style={{ width: `${Math.min(teamAchievement, 100)}%` }}></div>
            </div>
            <div className="mgr-achievement-target">
              Target: {formatCurrency(teamMetrics.totalTarget)} | Achieved: {formatCurrency(teamMetrics.totalRevenue)}
            </div>
          </div>
          <div className="mgr-achievement-right">
            <span className="mgr-growth-badge">{teamMetrics.monthlyGrowth} growth</span>
          </div>
        </div>

        {/* Team Metrics Grid */}
        <div className="mgr-metrics-grid">
          <div className="mgr-metric-card">
            <div className="mgr-metric-icon">👥</div>
            <div className="mgr-metric-info">
              <div className="mgr-metric-label">TEAM MEMBERS</div>
              <div className="mgr-metric-value">{teamMetrics.activeMembers}</div>
              <div className="mgr-metric-trend">Active</div>
            </div>
          </div>
          <div className="mgr-metric-card">
            <div className="mgr-metric-icon">📊</div>
            <div className="mgr-metric-info">
              <div className="mgr-metric-label">TOTAL LEADS</div>
              <div className="mgr-metric-value">{teamMetrics.totalLeads}</div>
              <div className="mgr-metric-trend up">↑ +8 vs last month</div>
            </div>
          </div>
          <div className="mgr-metric-card">
            <div className="mgr-metric-icon">🏆</div>
            <div className="mgr-metric-info">
              <div className="mgr-metric-label">DEALS WON</div>
              <div className="mgr-metric-value">{teamMetrics.totalDealsWon}</div>
              <div className="mgr-metric-trend up">↑ +3 vs last month</div>
            </div>
          </div>
          <div className="mgr-metric-card">
            <div className="mgr-metric-icon">💰</div>
            <div className="mgr-metric-info">
              <div className="mgr-metric-label">TEAM REVENUE</div>
              <div className="mgr-metric-value mgr-success">{formatCurrency(teamMetrics.totalRevenue)}</div>
            </div>
          </div>
          <div className="mgr-metric-card">
            <div className="mgr-metric-icon">⭐</div>
            <div className="mgr-metric-info">
              <div className="mgr-metric-label">WIN RATE</div>
              <div className="mgr-metric-value">{teamMetrics.avgWinRate}%</div>
            </div>
          </div>
          <div className="mgr-metric-card">
            <div className="mgr-metric-icon">⏳</div>
            <div className="mgr-metric-info">
              <div className="mgr-metric-label">PENDING APPROVALS</div>
              <div className="mgr-metric-value mgr-warning">{teamMetrics.pendingApprovals}</div>
            </div>
          </div>
        </div>

        {/* Team Members Table */}
        <div className="mgr-team-section">
          <h3 className="mgr-section-title">👥 Team Members Performance</h3>
          <div className="mgr-table-responsive">
            <table className="mgr-team-table">
              <thead>
                <tr>
                  <th>Member</th>
                  <th>Role</th>
                  <th>Leads</th>
                  <th>Deals Won</th>
                  <th>Revenue</th>
                  <th>Target</th>
                  <th>Achievement</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {teamMembers.map((member) => (
                  <tr key={member.id}>
                    <td className="mgr-member-cell">
                      <div className="mgr-member-avatar" style={{ backgroundColor: member.color }}>{member.avatar}</div>
                      <div>
                        <div className="mgr-member-name">{member.name}</div>
                        <div className="mgr-member-email">{member.email}</div>
                      </div>
                    </td>
                    <td><span className="mgr-role-badge">{member.role}</span></td>
                    <td>{member.leads}</td>
                    <td>{member.dealsWon}</td>
                    <td className="mgr-revenue-cell">{formatCurrency(member.achieved)}</td>
                    <td>{formatCurrency(member.target)}</td>
                    <td>
                      <div className="mgr-progress-wrapper">
                        <div className="mgr-progress-bar-small">
                          <div className="mgr-progress-fill" style={{ width: `${member.target > 0 ? (member.achieved / member.target) * 100 : 0}%` }}></div>
                        </div>
                        <span className="mgr-progress-percent">{member.target > 0 ? ((member.achieved / member.target) * 100).toFixed(0) : 0}%</span>
                      </div>
                    </td>
                    <td><span className="mgr-status-badge mgr-status-active">{member.status}</span></td>
                    <td>
                      <div className="mgr-action-buttons">
                        <button className="mgr-view-btn" onClick={() => viewMemberDetails(member)}>View</button>
                        <button className="mgr-target-btn" onClick={() => assignTarget(member)}>Set Target</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Charts Row */}
        <div className="mgr-charts-row">
          {/* Monthly Performance Chart */}
          <div className="mgr-chart-card">
            <h3 className="mgr-chart-title">📈 Monthly Team Performance vs Target</h3>
            <div className="mgr-trend-legend">
              <div className="mgr-trend-legend-item">
                <div className="mgr-trend-color mgr-trend-revenue"></div>
                <span>Revenue</span>
              </div>
              <div className="mgr-trend-legend-item">
                <div className="mgr-trend-color mgr-trend-target"></div>
                <span>Target</span>
              </div>
            </div>
            <div className="mgr-bar-chart-wrapper">
              <div className="mgr-bar-chart-container">
                {monthlyPerformance.map((item, index) => (
                  <div key={index} className="mgr-bar-chart-item">
                    <div className="mgr-bar-chart-bars">
                      <div className="mgr-bar-chart-bar-wrapper">
                        <div className="mgr-bar-chart-bar mgr-bar-revenue" style={{ height: `${(item.revenue / maxRevenue) * 150}px` }}>
                          <span className="mgr-bar-value">{formatCurrency(item.revenue)}</span>
                        </div>
                        <div className="mgr-bar-label">{item.month}</div>
                      </div>
                      <div className="mgr-bar-chart-bar-wrapper">
                        <div className="mgr-bar-chart-bar mgr-bar-target" style={{ height: `${(item.target / maxRevenue) * 150}px` }}>
                          <span className="mgr-bar-value-target">{formatCurrency(item.target)}</span>
                        </div>
                        <div className="mgr-bar-label">Target</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Recent Activities */}
          <div className="mgr-activities-card">
            <h3 className="mgr-chart-title">🔄 Recent Team Activities</h3>
            <div className="mgr-activities-list">
              {recentActivities.map((activity) => (
                <div key={activity.id} className="mgr-activity-item">
                  <div className="mgr-activity-icon">{getActivityIcon(activity.type)}</div>
                  <div className="mgr-activity-content">
                    <div className="mgr-activity-user">{activity.user}</div>
                    <div className="mgr-activity-action">
                      {activity.action}: <span className="mgr-activity-target">{activity.target}</span>
                    </div>
                    <div className="mgr-activity-time">{activity.time}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Quick Stats Row */}
        <div className="mgr-quick-stats">
          <div className="mgr-quick-stat">
            <div className="mgr-quick-stat-icon">🏆</div>
            <div>
              <div className="mgr-quick-stat-label">Top Performer</div>
              <div className="mgr-quick-stat-value">Priya Sharma</div>
            </div>
          </div>
          <div className="mgr-quick-stat">
            <div className="mgr-quick-stat-icon">📈</div>
            <div>
              <div className="mgr-quick-stat-label">Team Growth</div>
              <div className="mgr-quick-stat-value mgr-success">{teamMetrics.monthlyGrowth}</div>
            </div>
          </div>
          <div className="mgr-quick-stat">
            <div className="mgr-quick-stat-icon">⭐</div>
            <div>
              <div className="mgr-quick-stat-label">Avg Win Rate</div>
              <div className="mgr-quick-stat-value">{teamMetrics.avgWinRate}%</div>
            </div>
          </div>
          <div className="mgr-quick-stat">
            <div className="mgr-quick-stat-icon">📊</div>
            <div>
              <div className="mgr-quick-stat-label">This Month Revenue</div>
              <div className="mgr-quick-stat-value">{formatCurrency(monthlyPerformance[5]?.revenue || 0)}</div>
            </div>
          </div>
        </div>
      </div>

      {/* View Member Modal */}
      {isViewMemberModalOpen && selectedMember && (
        <div className="mgr-modal-overlay" onClick={() => setIsViewMemberModalOpen(false)}>
          <div className="mgr-modal mgr-view-modal" onClick={(e) => e.stopPropagation()}>
            <div className="mgr-modal-header">
              <h3>Member Details - {selectedMember.name}</h3>
              <button className="mgr-modal-close" onClick={() => setIsViewMemberModalOpen(false)}>×</button>
            </div>
            <div className="mgr-modal-body">
              <div className="mgr-details-grid">
                <div className="mgr-detail-row"><span className="mgr-detail-label">Name:</span><span className="mgr-detail-value">{selectedMember.name}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Role:</span><span className="mgr-detail-value">{selectedMember.role}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Email:</span><span className="mgr-detail-value">{selectedMember.email}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Phone:</span><span className="mgr-detail-value">{selectedMember.phone}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Join Date:</span><span className="mgr-detail-value">{formatDate(selectedMember.joinDate)}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Leads Generated:</span><span className="mgr-detail-value">{selectedMember.leads}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Deals Won:</span><span className="mgr-detail-value">{selectedMember.dealsWon}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Revenue Achieved:</span><span className="mgr-detail-value mgr-success">{formatCurrency(selectedMember.achieved)}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Target Assigned:</span><span className="mgr-detail-value">{formatCurrency(selectedMember.target)}</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Achievement:</span><span className="mgr-detail-value">{selectedMember.target > 0 ? ((selectedMember.achieved / selectedMember.target) * 100).toFixed(1) : 0}%</span></div>
                <div className="mgr-detail-row"><span className="mgr-detail-label">Status:</span><span className={`mgr-status-badge ${selectedMember.status === 'Active' ? 'mgr-status-active' : 'mgr-status-inactive'}`}>{selectedMember.status}</span></div>
              </div>
            </div>
            <div className="mgr-modal-footer">
              <button className="mgr-target-btn-modal" onClick={() => { setIsViewMemberModalOpen(false); assignTarget(selectedMember); }}>🎯 Set Target</button>
              <button className="mgr-cancel-button" onClick={() => setIsViewMemberModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Assign Target Modal */}
      {isAssignTargetModalOpen && selectedMember && (
        <div className="mgr-modal-overlay" onClick={() => setIsAssignTargetModalOpen(false)}>
          <div className="mgr-modal mgr-target-modal" onClick={(e) => e.stopPropagation()}>
            <div className="mgr-modal-header">
              <h3>🎯 Assign Target - {selectedMember.name}</h3>
              <button className="mgr-modal-close" onClick={() => setIsAssignTargetModalOpen(false)}>×</button>
            </div>
            <div className="mgr-modal-body">
              <div className="mgr-info-box">
                <p><strong>Current Achievement:</strong> {formatCurrency(selectedMember.achieved)}</p>
                <p><strong>Current Target:</strong> {formatCurrency(selectedMember.target)}</p>
              </div>

              <div className="mgr-form-group">
                <label>New Target Amount <span className="mgr-required">*</span></label>
                <input type="number" value={targetForm.target} onChange={(e) => setTargetForm({...targetForm, target: e.target.value})} placeholder="Enter target amount" />
              </div>

              <div className="mgr-form-group">
                <label>Quarter</label>
                <select value={targetForm.quarter} onChange={(e) => setTargetForm({...targetForm, quarter: e.target.value})}>
                  <option value="Q1">Q1 (Jan-Mar)</option>
                  <option value="Q2">Q2 (Apr-Jun)</option>
                  <option value="Q3">Q3 (Jul-Sep)</option>
                  <option value="Q4">Q4 (Oct-Dec)</option>
                </select>
              </div>

              <div className="mgr-form-group">
                <label>Additional Notes</label>
                <textarea rows="3" placeholder="Any specific instructions or notes..." value={targetForm.notes} onChange={(e) => setTargetForm({...targetForm, notes: e.target.value})} />
              </div>
            </div>
            <div className="mgr-modal-footer">
              <button className="mgr-cancel-button" onClick={() => setIsAssignTargetModalOpen(false)}>Cancel</button>
              <button className="mgr-save-button" onClick={submitTargetAssignment}>Assign Target</button>
            </div>
          </div>
        </div>
      )}

      {/* Approval Modal */}
      {isApproveModalOpen && (
        <div className="mgr-modal-overlay" onClick={() => setIsApproveModalOpen(false)}>
          <div className="mgr-modal mgr-approval-modal" onClick={(e) => e.stopPropagation()}>
            <div className="mgr-modal-header">
              <h3>⚡ Pending Approvals</h3>
              <button className="mgr-modal-close" onClick={() => setIsApproveModalOpen(false)}>×</button>
            </div>
            <div className="mgr-modal-body">
              <div className="mgr-approval-list">
                <div className="mgr-approval-item">
                  <div className="mgr-approval-info">
                    <div className="mgr-approval-title">PO Approval Required</div>
                    <div className="mgr-approval-desc">Purchase Order PO-2025-089 for ₹2.5L from Karan Verma</div>
                  </div>
                  <div className="mgr-approval-actions">
                    <button className="mgr-approve-btn" onClick={() => { alert('Approved!'); setIsApproveModalOpen(false); }}>✓ Approve</button>
                    <button className="mgr-reject-btn" onClick={() => { alert('Rejected!'); setIsApproveModalOpen(false); }}>✗ Reject</button>
                  </div>
                </div>
                <div className="mgr-approval-item">
                  <div className="mgr-approval-info">
                    <div className="mgr-approval-title">Quotation Review</div>
                    <div className="mgr-approval-desc">Quotation Q-2025-045 for Acme Industries - ₹9.2L</div>
                  </div>
                  <div className="mgr-approval-actions">
                    <button className="mgr-approve-btn" onClick={() => { alert('Approved!'); setIsApproveModalOpen(false); }}>✓ Approve</button>
                    <button className="mgr-reject-btn" onClick={() => { alert('Rejected!'); setIsApproveModalOpen(false); }}>✗ Reject</button>
                  </div>
                </div>
                <div className="mgr-approval-item">
                  <div className="mgr-approval-info">
                    <div className="mgr-approval-title">Contract Renewal</div>
                    <div className="mgr-approval-desc">Renewal request for Orbit Logistics - ₹13.2L</div>
                  </div>
                  <div className="mgr-approval-actions">
                    <button className="mgr-approve-btn" onClick={() => { alert('Approved!'); setIsApproveModalOpen(false); }}>✓ Approve</button>
                    <button className="mgr-reject-btn" onClick={() => { alert('Rejected!'); setIsApproveModalOpen(false); }}>✗ Reject</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="mgr-modal-footer">
              <button className="mgr-cancel-button" onClick={() => setIsApproveModalOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Generate Report Modal */}
      {isReportModalOpen && (
        <div className="mgr-modal-overlay" onClick={() => setIsReportModalOpen(false)}>
          <div className="mgr-modal mgr-report-modal" onClick={(e) => e.stopPropagation()}>
            <div className="mgr-modal-header">
              <h3>📊 Generate Performance Report</h3>
              <button className="mgr-modal-close" onClick={() => setIsReportModalOpen(false)}>×</button>
            </div>
            <div className="mgr-modal-body">
              <div className="mgr-form-group">
                <label>Report Period</label>
                <select value={reportPeriod} onChange={(e) => setReportPeriod(e.target.value)}>
                  <option value="weekly">Weekly Report</option>
                  <option value="monthly">Monthly Report</option>
                  <option value="quarterly">Quarterly Report</option>
                  <option value="yearly">Yearly Report</option>
                </select>
              </div>

              <div className="mgr-form-group">
                <label>Report Type</label>
                <select>
                  <option>Team Performance Summary</option>
                  <option>Individual Performance Report</option>
                  <option>Revenue Analysis</option>
                  <option>Lead Conversion Report</option>
                </select>
              </div>

              <div className="mgr-form-group">
                <label>Format</label>
                <select>
                  <option>PDF Document</option>
                  <option>Excel Spreadsheet</option>
                  <option>CSV Export</option>
                </select>
              </div>
            </div>
            <div className="mgr-modal-footer">
              <button className="mgr-cancel-button" onClick={() => setIsReportModalOpen(false)}>Cancel</button>
              <button className="mgr-generate-btn" onClick={generateReport}>Generate Report</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManagerDashboard;